import {
  AfterViewInit,
  Component,
  EnvironmentInjector,
  Input,
  ViewChild,
  ViewContainerRef,
  createComponent,
} from "@angular/core";
import { Page, TemplatePage } from "@app/data/catalog";
import { XMLParser, XMLBuilder } from "fast-xml-parser";
import { ContainerComponent } from "./components/container.component";

@Component({
  selector: "app-catalog-page",
  templateUrl: "./catalog-page.component.html",
})
export class CatalogPageComponent implements AfterViewInit {
  _page: TemplatePage;
  @Input() isPreview: boolean = false;
  debounceTimer: any;
  content: Record<string, any> = {};

  constructor() {}

  private async compileTemplate(template: string) {
    if (!template) {
      return;
    }
    const parser = new XMLParser({
      attributeNamePrefix: "",
      attributesGroupName: "attributes",
      ignoreAttributes: false,
      allowBooleanAttributes: true,
      parseAttributeValue: true,
    });
    this.content = parser.parse(template);
  }
  // async parseAndLoopXML(xml: string): Promise<void> {
  //   try {
  //     // Parse the XML string to a JavaScript object
  //     const result = await parseStringPromise(xml);

  //     // Loop through the items
  //     if (result.root && result.root.item) {
  //       for (const item of result.root.item) {
  //         console.log("Name:", item.name[0]);
  //         console.log("Value:", item.value[0]);
  //       }
  //     }
  //   } catch (err) {
  //     console.error("Error parsing XML:", err);
  //   }
  // }

  refresh() {
    if (this.page) {
      this.compileTemplate(this.page.layout);
    }
  }

  ngAfterViewInit() {
    this.refresh();
  }

  @Input() get page(): TemplatePage {
    return this._page;
  }

  set page(page: TemplatePage) {
    this._page = page;
    console.log("debounce");
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.compileTemplate(page.layout);
    }, 1000);
  }
}
